import featureFlagsProd from "../feature-flags.prod.json";
import featureFlagsDev from "../feature-flags.dev.json";

const isProduction =
  process.env.VERCEL_ENV === "production" &&
  process.env.VERCEL_GIT_COMMIT_REF === "main";
const FEATURE_FLAGS = isProduction ? featureFlagsProd : featureFlagsDev;

export default FEATURE_FLAGS;
